import CrudCustom from '../../../libs/custom/CrudCustom';

let PengaturanPenghasilanPPhService = new CrudCustom('/tipe-penambah-ph-brutos');
export default PengaturanPenghasilanPPhService;
